<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style=" border-radius: 5px !important;padding-left:0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previosMaintain" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Shipping Line Branch</b-navbar-brand>

          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button
                size="sm"
                variant="warning"
                v-if="showMain==false"
                @click="goToMain"
              >New Branch</b-button>
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <div v-if="showMain==true">
              <b-container>
                <b-card style="background:whiteSmoke">
                  <md-layout md-gutter>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="35">
                      <md-layout md-flex="100">
                        <label>Branch Name</label>
                        <b-form-input :formatter="capitalizeAll"
                          id="shippingBranch"
                          name="shippingBranch"
                          v-model="shipLine.shippingBranch"
                        ></b-form-input>
                      </md-layout>
                      <span class="error" v-if="!shipLine.shippingBranch">{{shippingLineError}}</span>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="20">
                      <md-layout md-flex="100">
                        <label>GST No</label>
                        <b-form-input :formatter="capitalizeAll" id="gstNo" name="gstNo" v-model="shipLine.gstNo"></b-form-input>
                      </md-layout>
                      <!-- <span class="error" v-if="!shippingLine">{{shippingLineError}}</span> -->
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="25">
                      <md-layout md-flex="100">
                        <label>PAN No</label>
                        <b-form-input :formatter="capitalizeAll" id="panNo" name="panNo" v-model="shipLine.panNo"></b-form-input>
                      </md-layout>
                      <!-- <span class="error" v-if="!shippingLine">{{shippingLineError}}</span> -->
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter class="gutr">
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="35">
                      <md-layout md-flex="100">
                        <label>Contact Person Name</label>
                        <b-form-input :formatter="capitalizeAll"
                          id="contactPerson"
                          name="contactPerson"
                          v-model="shipLine.contactPerson"
                        ></b-form-input>
                      </md-layout>
                      <!-- <span class="error" v-if="!shippingLine">{{shippingLineError}}</span> -->
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="20">
                      <md-layout md-flex="100">
                        <label>Contact No</label>
                        <b-form-input :formatter="capitalizeAll" id="contactNo" name="contactNo" v-model="shipLine.contactNo"></b-form-input>
                      </md-layout>
                      <!-- <span class="error" v-if="!shippingLine">{{shippingLineError}}</span> -->
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="25">
                      <md-layout md-flex="100">
                        <label>Email-Id</label>
                        <b-form-input :formatter="capitalizeAll" id="email" name="email" v-model="shipLine.email"></b-form-input>
                      </md-layout>
                      <!-- <span class="error" v-if="!shippingLine">{{shippingLineError}}</span> -->
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter class="gutr">
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="90">
                      <md-layout md-flex="100">
                        <label>Shipping Line Address</label>
                        <b-form-textarea :formatter="capitalizeAll" id="address" name="address" v-model="shipLine.address"></b-form-textarea>
                      </md-layout>
                      <!-- <span class="error" v-if="!shippingLine">{{shippingLineError}}</span> -->
                    </md-layout>
                  </md-layout>

                  <md-layout md-gutter class="mrgtop-2per gutr">
                    <md-layout md-flex="85"></md-layout>
                    <md-layout md-flex="15">
                      <b-button
                        variant="primary"
                        @click="addVehicleSize"
                        id="addButtonLoader"
                      >{{shipLine.shippingBranchId==''?"Add":"Update"}}</b-button>
                      <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
                    </md-layout>
                  </md-layout>
                </b-card>
              </b-container>
            </div>

            <div class="box">
              <!-- /.box-header -->
              <div class="box-body gutr">
                <table id="shipping" class="table">
                  <thead>
                    <tr>
                      <th>Sr.no</th>

                      <th>Branch</th>
                      <th>Contact Details</th>
                      <!-- <th>Edit</th> -->
                      <!-- <th>Delete</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item1,index) in shippingDetails" :key="index">
                      <td>{{index+1}}</td>
                      <td class="showMoreData" @click="editData(item1)">
                        <b>{{item1.shippingBranch}}</b>

                        <br>
                        <span>GST No. :</span>
                        {{item1.gstNo}}
                        <br>
                        <span>PAN No. :</span>
                        {{item1.panNo}}
                      </td>
                      <td>
                        <span>Address :</span>
                        {{item1.address}}
                        <br>
                        <span>Contact Person Name :</span>
                        {{item1.contactPerson}}
                        <br>
                        <span>Contact No. :</span>
                        {{item1.contactNo}}
                        <br>
                        <span>Email :</span>
                        {{item1.email}}
                      </td>

                      <!-- <td>
                    <md-button class="md-icon-button md-raised md-dense" @click="editData(item1)">
                      <md-icon>edit</md-icon>
                    </md-button>
                      </td>-->
                      <!-- <td>
                    <md-button
                      class="md-icon-button md-raised md-dense"
                      @click="deleteData(item1.shippingBranchId)"
                    >
                      <md-icon>delete_sweep</md-icon>
                    </md-button>
                      </td>-->
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.box-body -->
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose6"
      ref="addPop6"
    ></md-dialog-confirm>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop3"></md-dialog-alert>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";

export default {
  beforeMount() {
    if (globalPermissionStatus("Main Master")) {
      this.$store.dispatch("setCurrentRoute", "/yard/shipping");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  data() {
    return {
      isLoading: false,
      showMain: false,
      shipLine: {
        shippingBranchId: "",
        shippingId: "",
        shippingBranch: "",
        gstNo: "",
        panNo: "",
        contactPerson: "",
        contactNo: "",
        email: "",
        address: ""
      },
      alert: {
        content: "Added Succesfully",
        ok: "ok"
      },
      deleteId: "",
      shippingLine: "",
      vehicleSizeMaster: [{}],
      shippingDetails: [],
      validate: true,
      shippingLineError: "",
      excelUpload: ""
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    // Loading
    CustomLoader,
  },
  computed: {},
  methods: {
    previosMaintain() {
      this.$sessionsStorage.set("branchShipId", "");
      this.$router.push({
        path: "/yard/shipping"
      });
    },
    goToMain() {
      this.showMain = true;
    },
    // // JqueryFun() {
    // //   return $(function() {
    // //     return $("#shipping").DataTable();
    // //   });
    // // },

    validateAddVehicleSizeForm() {
      let validate_new = true;

      if (this.shipLine.shippingLine == "") {
        $("#shippingLine").focus();
        this.shippingLineError = "Enter Shipping Line Name";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    editData(item) {
      this.showMain = true;

      Object.keys(this.shipLine).map(x => {
        this.shipLine[x] = item[x] || "";
      });
    },

    addVehicleSize() {
      this.shipLine["shippingId"] = this.$sessionsStorage.get("branchShipId");
      this.validateAddVehicleSizeForm();
      //      let new_Size_Data={

      // shippingLine:this.shippingLine
      // }

      if (this.validate != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Yard/shippingLineBranchAdd.php`,
          data: JSON.stringify(this.shipLine),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            $("#addButtonLoader").css("display", "block");
            $("#loader").css("display", "none");
            console.log(result.data);
            if (result.data.Id != "" && result.data.Id != undefined) {
              if (this.shipLine.shippingBranchId == "") {
                this.alert.content = "Data Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
              }

              this.$refs["addPop6"].open();

              this.getData();
              Object.keys(this.shipLine).map(x => {
                this.shipLine[x] = "";
              });
              this.shippingLineError = "";
              this.showMain = false;

              // this.JqueryFun();
            }
          })
          .catch(error => {});
      }
    },

    getData() {
      this.isLoading = true;
      let type_Size = {
        truckSize: "truckSize",
        shippingId: this.$sessionsStorage.get("branchShipId")
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Yard/shippingLineBranchDetails.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if (data.branchData.length > 0) {
              this.shippingDetails = data.branchData;
            }
            //  console.log("fsf",data.truckSizeDetails)
            this.isLoading = false;
            // this.JqueryFun();
          }
        })
        .catch(error => {});
    },
    downloadExcel() {
      let excelName = {
        excelName: "VehicleSizeMaster",
        validExcel: "yes"
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/downloadMasterExcel.php`,
        data: JSON.stringify(excelName),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            // console.log(data);
            // console.log(data.link12);

            window.open(data.link12);
          }
        })
        .catch(error => {});
    },

    onFileChange() {
      var files = event.target.files || event.dataTransfer.files;
      // this.uploadCheck = files[0];
      var formData = new FormData();

      for (let i = 0; i < files.length; i++) {
        formData.append(`vehicleSizeMaster[]`, files[i]);
      }
      const config = {
        headers: { "content-type": "multipart/form-data" }
      };

      axios
        .post(`${URL_BASE}/uploadExcelDataMaster.php`, formData, config)
        .then(result => {
          console.log(result.data);
          if (result.data == "Only XLXS Format Support") {
            this.alert.content = "Only .xlxs format support";
          } else {
            this.alert.content = result.data;
          }
          this.$refs["addPop"].open();
          this.getData();
        })
        .catch(err => {
          throw err;
        });
    },
    deleteData(id) {
      this.deleteId = id;
      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPop6"].open();
    },
    onClose6(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "shippinglinemaster",
          tableId: "shippingBranchId",
          tableIsActive: "isShippingActive",
          tableVal: this.deleteId
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Yard/deleteData.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if (
              data.clientId != "" &&
              
              status == 200 &&
              data
            ) {
              // this.JqueryFun();
              this.getData();
              // console.log(data);
            }
          })
          .catch(error => {});
      }
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// newShippingBranch.vue?7b3bb970